import React from 'react';
import {PublicApiCumulativeTotalsByProgressResponse, PublicApiCumulativeTotalsResponse} from "../Representation";
import {IconCircleCheck, IconShoppingCart, IconTruckFast} from "./Icons";

interface CumulativeTotalsProps {
    cumulativeTotals: PublicApiCumulativeTotalsResponse[]
    cumulativeTotalsByProgress: PublicApiCumulativeTotalsByProgressResponse
    cumulativeTotalsConsignmentCount: number
}

type ModeType = 'BY_PROGRESS' | 'TOTALS_ONLY'
const mode = 'BY_PROGRESS' as ModeType;

type QtyType = 'ORDERED' | 'IN_TRANSIT' | 'DELIVERED';

const CumulativeTotals = (
    props: CumulativeTotalsProps
) => {

    if (!props.cumulativeTotals || !props.cumulativeTotalsByProgress || props.cumulativeTotalsConsignmentCount <= 1) {
        return null;
    }

    const cumulativeTotalRow = (row: PublicApiCumulativeTotalsResponse, qtyType: QtyType, index: number) => {
        let qty;
        switch (qtyType) {
            case 'ORDERED':
                qty = row.totalOrderedQuantity;
                break;
            case 'IN_TRANSIT':
                qty = row.totalInTransitQuantity;
                break;
            case 'DELIVERED':
                qty = row.totalDeliveredQuantity;
                break;
            default:
                console.error("Unknown qtyType: " + qtyType);
                return null;
        }
        return (
            <div key={"row_" + index}>
                <p className="title">{row.productDescription}</p>
                <p className="qty">{qty} <span className="ConsignmentFreight-uom">{ row.unitOfMeasureDescription }</span></p>
            </div>
        )
    }

    return (
        <>
            <hr />
            <h3>Today's Total Quantities</h3>
            {mode === 'TOTALS_ONLY'
                ? props.cumulativeTotals.map((row, index) => {
                    return cumulativeTotalRow(row, 'DELIVERED', index);
                })
                : null
            }
            {mode === 'BY_PROGRESS' &&
                <div className="flex-container">
                    <div className="col-scheduled">
                        <h4><IconShoppingCart /> Scheduled</h4>
                        <div className="col-cumulative">
                            {props.cumulativeTotalsByProgress.scheduled.map((row, index) => cumulativeTotalRow(row, 'ORDERED', index))}
                        </div>
                    </div>
                    <div className="col-in-transit">
                        <h4><IconTruckFast /> In Transit</h4>
                        <div className="col-cumulative">
                            {props.cumulativeTotalsByProgress.inTransit.map((row, index) => cumulativeTotalRow(row, 'IN_TRANSIT', index))}
                        </div>

                    </div>
                    <div className="col-delivered">
                        <h4><IconCircleCheck /> Delivered</h4>
                        <div className="col-cumulative">
                            {props.cumulativeTotalsByProgress.completed.map((row, index) => cumulativeTotalRow(row, 'DELIVERED', index))}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default CumulativeTotals;
